import EmailIcon from '@atlaskit/icon/glyph/email';
import EmojiFrequentIcon from '@atlaskit/icon/glyph/emoji/frequent';
import MobileIcon from '@atlaskit/icon/glyph/mobile';
import { humanizeSupportTimings } from '@atlassian/mpac-utils';
import * as React from 'react';
import { SupportAvailability } from '../../types';
import { getPartnerSupportAvailability } from '../../utils';
import { ContactDetail, ContactItem, ContactLink, ContactList } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SupportContactDetails = props => {
  const {
    supportDetails: {
      availability,
      contact: {
        emailId,
        phoneNumber
      }
    }
  } = props;
  const supportTimings = availability && humanizeSupportTimings(availability);
  const availabilityType = availability && getPartnerSupportAvailability({
    availability,
    localTime: Date.now()
  });
  const isClosed = availabilityType !== SupportAvailability.Open;
  return /*#__PURE__*/_jsxs(ContactList, {
    children: [supportTimings && /*#__PURE__*/_jsxs(ContactItem, {
      children: [/*#__PURE__*/_jsx(EmojiFrequentIcon, {
        label: "Support Timings"
      }), /*#__PURE__*/_jsxs(ContactDetail, {
        children: [isClosed ? 'Open from ' : '', supportTimings]
      })]
    }), emailId && /*#__PURE__*/_jsxs(ContactItem, {
      children: [/*#__PURE__*/_jsx(EmailIcon, {
        label: "Contact Email"
      }), /*#__PURE__*/_jsx(ContactDetail, {
        children: /*#__PURE__*/_jsx(ContactLink, {
          href: "mailto:".concat(emailId),
          size: "medium",
          "aria-label": "Support contact email open in external email app",
          children: emailId
        })
      })]
    }), phoneNumber && /*#__PURE__*/_jsxs(ContactItem, {
      children: [/*#__PURE__*/_jsx(MobileIcon, {
        label: "Contact phone"
      }), /*#__PURE__*/_jsx(ContactDetail, {
        children: /*#__PURE__*/_jsx(ContactLink, {
          href: "tel:".concat(phoneNumber),
          size: "medium",
          "aria-label": "Support contact phone open in external caller",
          children: phoneNumber
        })
      })]
    })]
  });
};